import { ButtonTypography } from "@coherehealth/common";
import React from "react";
import { Box } from "@mui/material";

interface DashboardTitleProps {
  title: string;
  applyPadding: boolean;
}

const DashboardTitle = ({ title, applyPadding }: DashboardTitleProps) => {
  return title ? (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <ButtonTypography
        style={{
          color: "#6F7580",
          fontFamily: "Figtree, sans-serif",
          fontSize: "19px",
          fontWeight: "600",
          letterSpacing: "0.25px",
          lineHeight: "20px",
          marginRight: "0.5em",
          paddingBottom: applyPadding ? "0.5em" : "0em",
        }}
      >
        {title}
      </ButtonTypography>
    </Box>
  ) : (
    <></>
  );
};

export default DashboardTitle;
